import { useMutation } from '@tanstack/react-query';
import { downloadChat } from './users.api';
export const useDownloadChatMutation = () => {
    return useMutation({
        mutationFn: downloadChat
    });
};
//# sourceMappingURL=users.query.js.map